export const AUDIT_LIST_REQUEST = 'AUDIT_LIST_REQUEST'
export const AUDIT_LIST_SUCCESS = 'AUDIT_LIST_SUCCESS'
export const AUDIT_LIST_FAIL = 'AUDIT_LIST_FAIL'